import type { LinkProps } from '../link'

import { useStyleConfig, vui } from '../core'
import Link from '../link'
import { cs } from '../utils'
import { useFooterContext } from './context'

/** Individual link item of the Footer. */
export const FooterLink = vui<'a', LinkProps>((props, ref) => {
  const { className, py, ...rest } = props
  const styles = useStyleConfig('Footer', useFooterContext())

  return (
    <Link
      className={cs('vui-footerLink', className)}
      display={'inline-block'}
      py={py ?? { _: 0.5, xs: 0, sm: 0, md: 0.5 }}
      ref={ref}
      size={{ _: 'sm', md: 'md' }}
      variant="white"
      {...styles.link}
      {...rest}
    />
  )
})

FooterLink.displayName = 'FooterLink'
export default FooterLink
